import {StoryStatus} from '@graphql/types'
import type {UiStories, UiStoryNode} from './stories.types'

const defaultStory: UiStoryNode = {
  id: '',
  uid: '',
  canonicalUrl: '',
  title: '',
  isActive: false,
  status: StoryStatus.Active,
  description: '',
  updatedAt: new Date(),
  publicationsCount: 0,
  figureVersion: {
    id: '',
    uid: '',
    primaryProcessedImage: {
      url: ''
    },
    figure: {
      id: '',
      uid: ''
    }
  }
}

const defaultStories: UiStories = {
  pageInfo: {
    hasNextPage: false,
    endCursor: ''
  },
  edges: [
    {
      node: defaultStory
    }
  ]
}

export {defaultStory, defaultStories}
